import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getDeviationTitle } from '../DeviationViews/_helpers';
import { ModalType } from '../Modals/redux/types';
import { pushModal } from '../Modals/redux/basicActions';
// ---- actionCreator pulled out to make redux Loadable
export const showDeviationGroupListPopup = (params)=>pushModal(ModalType.DEVIATION_GROUP_LIST, {
        params
    });
/** Returns an already dispatched action that pushes the DeviationGroupListPopup.
 *  Use this to open the modal */ export default function useDeviationGroupListPopup(deviation) {
    var _deviation_extended, _deviation_extended1;
    const { deviationId } = deviation;
    const title = getDeviationTitle(deviation);
    const canRemoveFromGroup = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserEdit;
    const url = (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.groupListUrl;
    const dispatch = useDispatch();
    const dispatchedShowDeviationGroupListPopup = useCallback(()=>{
        dispatch(showDeviationGroupListPopup({
            deviationId,
            canRemoveFromGroup,
            title,
            url
        }));
    }, [
        dispatch,
        deviationId,
        canRemoveFromGroup,
        url,
        title
    ]);
    return dispatchedShowDeviationGroupListPopup;
}
